import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { Card, CardBody, Col, Container, Button, Row } from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import { CheckPermission } from "../Permissions/CheckPermissions";
import { CircularProgress } from "@material-ui/core";
import { FaPen, FaPlus } from "react-icons/fa";

const CarparkModal = (props) => {
  const sortOptions = [
    { id: 1, value: "enabled", label: "Enabled" },
    { id: 2, value: "all", label: "All" },
  ];
  const [sortBy, setSortBy] = useState(sortOptions[0].value);
  const [token, setToken] = useState();
  const [data, setData] = useState([]);
  const [del, setDelete] = useState(false);
  const [successAlert, setSuccesAlert] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [itemForDelete, setItemForDelete] = useState(null);
  const [errorAlert, setErrorAlert] = useState(false);
  const [loading, setloading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("AuthenticationToken");
    setToken(token);
    getData(token);
  }, []);


  const getData = (token) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append(
      "Cookie",
      "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208"
    );

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_TOKRI_API_URL}/api/carparkmodal?pageSize=-1&rich_html=true`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        setloading(false);
        // API directly returns carparkmodal data, no need to filter
        let data = Array.isArray(result) ? result : [];
        setData(data);
      })
      .catch((error) => {
        console.log("error", error);
        setloading(false);
        setData([]);
      });
  };

  const handleConfirmation = () => {
    return (
      <SweetAlert
        title="Warning"
        warning
        showCancel={true}
        showConfirm={true}
        btnSize="lg"
        confirmBtnText="Delete"
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="secondary"
        onConfirm={() => {
          if (itemForDelete) {
            deleteEntry(itemForDelete?.id || itemForDelete, token);
          }
          setDelete(false);
        }}
        onCancel={() => setDelete(false)}
        show={true}
      >
        {"Are you sure you want to delete ?"}
      </SweetAlert>
    );
  };
  const renderSuccessAlert = () => {
    return (
      <SweetAlert
        title="Success!"
        success
        confirmBtnBsStyle="success"
        onConfirm={() => {
          props.history.go(0);
          setSuccesAlert(false);
        }}
        onCancel={() => {
          setSuccesAlert(false);
        }}
      >
        {"Rewards Modal deleted"}
      </SweetAlert>
    );
  };

  const renderFailureAlert = () => {
    return (
      <SweetAlert
        title="Warning!"
        warning
        confirmBtnBsStyle="warning"
        onConfirm={() => {
          setErrorAlert(false);
        }}
      >
        {"Error. Something went wrong."}
      </SweetAlert>
    );
  };

  const deleteEntry = (ID, token) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_TOKRI_API_URL}/api/carparkmodal/${ID}`,
      requestOptions
    )
      .then((response) => {
        if (response.status === 200) {
          setSuccesAlert(true);
        } else {
          setErrorAlert(true);
        }
        response.text();
      })
      .then((result) => console.log(result))
      .catch((error) => console.log("error", error));
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs breadcrumbItem="Rewards Modal" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <Row>
                    <Col md={4}>
                      <Button
                        disabled={!CheckPermission("moreSection", "add")}
                        className="btn btn-success waves-effect waves-light"
                        onClick={() => {
                          props?.history?.push("/add-rewards-modal");
                        }}
                      >
                        <FaPlus size={12} /> Add Rewards Modal
                      </Button>
                    </Col>
                    <Col md={8} className="d-flex justify-content-md-end">
                      <div className="mb-3">
                        {/* <Label>Discount Type</Label> */}
                        <label htmlFor="cars">Status</label>

                        <select
                          name="cars"
                          defaultValue={sortOptions[0].value}
                          id="cars"
                          onChange={(e) => {
                            setSortBy(e.target.value);
                          }}
                          style={{ width: 80, height: 30, marginLeft: 10 }}
                          options={sortOptions}
                        >
                          {sortOptions?.map((item, index) => {
                            return (
                              <option key={index} value={item.value}>
                                {item.label}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </Col>
                  </Row>
                  {loading ? (
                    <div role="status" style={{ textAlign: "center" }}>
                      <CircularProgress size={50} value={100} color={"black"} />
                    </div>
                  ) : (
                    <div className="table-responsive mt-3">
                      <table
                        style={{ tableLayout: "fixed" }}
                        className="table table-bordered border-primary mb-0"
                      >
                        <thead>
                          <tr>
                            <th style={{ width: "140px" }}>Reward Type</th>
                            <th style={{ width: "140px" }}>Reward Category</th>
                            <th>Confirmation Message</th>
                            <th>Purchase Message</th>
                            <th style={{ width: "120px" }}>Status</th>
                            <th style={{ width: "7%" }}>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data?.length > 0 ? (
                            data?.map((item, index) => {
                              if (sortBy === "enabled") {
                                if (item?.status !== "Y") {
                                  return null;
                                }
                              }
                              return (
                                <tr key={item?.id || index}>
                                  <td>{item?.reward_type || "-"}</td>
                                  <td>{item?.reward_category || "-"}</td>
                                  <td>
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: item?.confirmation_message || "-",
                                      }}
                                    />
                                  </td>
                                  <td>
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: item?.purchase_message || "-",
                                      }}
                                    />
                                  </td>
                                  <td style={{textAlign:"center"}}>
                                    <Button
                                      color={
                                        item.status === "Y" ? "success" : "danger"
                                      }
                                    >
                                      {item.status === "Y"
                                        ? "Enabled"
                                        : "Disabled"}
                                    </Button>
                                  </td>
                                  <td>
                                    <Row>
                                      <div className="d-flex justify-content-around">
                                        {CheckPermission(
                                          "moreSection",
                                          "update"
                                        ) && (
                                          <div
                                            style={{
                                              width: 30,
                                              textAlign: "center",
                                            }}
                                            className="text-primary"
                                          >
                                            <div
                                              className="font-size-18"
                                              style={{ cursor: "pointer" }}
                                              onClick={() => {
                                                props?.history?.push(
                                                  "/edit-rewards-modal",
                                                  {
                                                    edit: true,
                                                    item: item
                                                  }
                                                );
                                              }}
                                            ><FaPen /></div>
                                          </div>
                                        )}
                                      </div>
                                    </Row>
                                  </td>
                              </tr>
                            );
                            })
                          ) : (
                            <tr>
                              <td colSpan="6" style={{ textAlign: "center" }}>
                                No data available
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
          {del ? handleConfirmation() : null}
          {successAlert ? renderSuccessAlert() : null}
          {errorAlert ? renderFailureAlert() : null}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default CarparkModal;

